"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderSummary = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _config = require("../../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    // checkout side menu
    checkoutMenuContainer: {
      top: 100,
      position: 'sticky'
    },
    totalPriceContainer: {
      borderTop: '1px solid #f1f1f2',
      marginTop: 7,
      paddingTop: 7
    },
    buttonContainer: _defineProperty({
      paddingLeft: 30,
      paddingRight: 30,
      paddingTop: 50
    }, theme.breakpoints.down('xl'), {
      paddingLeft: 'initial',
      paddingRight: 'initial'
    }),
    container: {
      padding: '2rem',
      paddingBottom: '2rem'
    },
    itemContainer: {
      marginTop: 5
    },
    titleContainer: {
      paddingBottom: '2rem'
    },
    nextButtonContainer: _defineProperty({
      marginTop: 10
    }, theme.breakpoints.down('sm'), {
      marginBottom: 20
    }),
    imageContainer: {
      paddingTop: '2.5rem'
    },
    image: {
      width: '30%'
    },
    imageDescription: {
      paddingTop: '0.25rem'
    },
    description: {
      color: '#686868'
    },
    balanceTextColor: {
      color: theme.palette.success.main
    }
  };
});
var OrderSummary = function OrderSummary(props) {
  var classes = useStyles();
  var itemsNumber = props.itemsNumber,
    subTotal = props.subTotal,
    totalAmount = props.totalAmount,
    total = props.total,
    shippingAmount = props.shippingAmount,
    hasShipping = props.hasShipping,
    step = props.step,
    onClickNext = props.onClickNext,
    onClickPrevious = props.onClickPrevious,
    buttonTitleToGoToNextStep = props.buttonTitleToGoToNextStep,
    disabledNextButton = props.disabledNextButton,
    balance = props.balance,
    buyerCommission = props.buyerCommission,
    subTotalOriginal = props.subTotalOriginal,
    cautionTotal = props.cautionTotal,
    reservationDays = props.reservationDays,
    isReservation = props.isReservation;
  var totalOriginal = subTotalOriginal + (shippingAmount || 0) + (buyerCommission || 0) + (cautionTotal || 0);
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    className: classes.checkoutMenuContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    className: classes.titleContainer,
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h4"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Order summary",
    defaultMessage: "Order summary"
  })))), balance !== undefined && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "space-between",
    className: classes.itemContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.balanceTextColor
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Your balance",
    defaultMessage: "Your balance"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.balanceTextColor
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: balance,
    style: "currency",
    currency: "EUR"
  })))), subTotal !== undefined && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "space-between",
    className: classes.itemContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Subtotal",
    defaultMessage: "Subtotal"
  }), " (", isReservation ? reservationDays : itemsNumber, " ", (isReservation ? reservationDays : itemsNumber) > 1 ? /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: isReservation ? 'days' : 'items'
  }) : /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: isReservation ? 'day' : 'item'
  }), ")")), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, _config.PROPOSITIONS_USED_IN_CHAT && !_lodash.default.isEmpty(subTotalOriginal) && subTotalOriginal !== subTotal && /*#__PURE__*/_react.default.createElement("del", null, /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: subTotalOriginal,
    style: "currency",
    currency: "EUR"
  })), "\xA0", /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: subTotal,
    style: "currency",
    currency: "EUR"
  })))), hasShipping && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "space-between",
    className: classes.itemContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Livraison",
    defaultMessage: "Livraison"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, shippingAmount !== undefined ? /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: shippingAmount,
    style: "currency",
    currency: "EUR"
  }) : /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "To calculate",
    defaultMessage: "To calculate"
  })))), buyerCommission && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "space-between",
    className: classes.itemContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Buyer commission",
    defaultMessage: "Buyer commission"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: buyerCommission,
    style: "currency",
    currency: "EUR"
  })))), !!cautionTotal && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "space-between",
    className: classes.itemContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Caution Total"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: cautionTotal,
    style: "currency",
    currency: "EUR"
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "space-between",
    className: classes.itemContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Co\xFBt total",
    defaultMessage: "Co\xFBt total"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, _config.PROPOSITIONS_USED_IN_CHAT && !_lodash.default.isEmpty(totalOriginal) && totalOriginal !== totalAmount && /*#__PURE__*/_react.default.createElement("del", null, /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: totalOriginal,
    style: "currency",
    currency: "EUR"
  })), "\xA0", /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: totalAmount,
    style: "currency",
    currency: "EUR"
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "space-between",
    className: classes.totalPriceContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "TOTAL",
    defaultMessage: "TOTAL"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, _config.PROPOSITIONS_USED_IN_CHAT && !_lodash.default.isEmpty(totalOriginal) && totalOriginal !== total && /*#__PURE__*/_react.default.createElement("del", null, /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: totalOriginal,
    style: "currency",
    currency: "EUR"
  })), "\xA0", /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: total,
    style: "currency",
    currency: "EUR"
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "center",
    className: classes.buttonContainer
  }, step > 0 && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 3,
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "text",
    color: "default",
    disableElevation: true,
    fullWidth: true,
    size: "large",
    onClick: onClickPrevious,
    startIcon: /*#__PURE__*/_react.default.createElement(_ArrowBack.default, null)
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Retour",
    defaultMessage: "Retour"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: step > 0 ? 7 : 12,
    alignItems: "center",
    justifyContent: "center",
    className: classes.nextButtonContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: _config.USE_PRIMARY_COLOR ? "primary" : "secondary",
    disabled: disabledNextButton,
    disableElevation: true,
    fullWidth: true,
    size: "large",
    onClick: onClickNext
  }, buttonTitleToGoToNextStep))))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "center",
    className: classes.imageContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "".concat(_config.STATIC_PATH, "/assets/images/payment-solutions.jpg"),
    alt: "payment-solutions",
    className: classes.image
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    alignItems: "center",
    justifyContent: "center",
    className: classes.imageDescription
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.description
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Moyens de paiement adapt\xE9s et s\xE9curis\xE9s",
    defaultMessage: "Moyens de paiement adapt\xE9s et s\xE9curis\xE9s"
  }))));
};
exports.OrderSummary = OrderSummary;